var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.setPoints),function(point){return [_c('measure-draggable',{key:`${_vm.getArea.projection}-${point.pointNumber}`,attrs:{"point":point,"flipped":_vm.flipped},on:{"onEnd":_vm.calculatePosition}})]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }